import { Component, Prop, Vue } from 'vue-property-decorator';
import { reportFormValidity } from '@/helpers/Validation';
import FormInput from '@/components/forms/FormInput2.vue';
import { API } from '@/api/API';
import { isValidationError } from '@/errors/ValidationError';
import { apiErrorMessageOrRethrow } from '@/errors/helpers';
/**
 * A form with just one email address field and a submit button.
 * Re-used in Forgotten Password, Forgotten Membership and Resend Order.
 */
@Component({
    name: 'EmailSubmitForm',
    components: {
        FormInput,
    },
})
export default class default_1 extends Vue {
    @Prop()
    submitText;
    @Prop()
    postRoute;
    @Prop({ default: () => { } })
    extraPostParams;
    @Prop({ default: false })
    treat404AsSuccess;
    @Prop({ default: '' })
    custom404Message;
    email = null;
    submitting = false;
    error = null;
    success = false;
    reportSuccess() {
        this.success = true;
        this.$emit('success', this.email);
    }
    async submit() {
        this.error = null;
        this.success = false;
        try {
            await reportFormValidity(this.$refs.form);
            this.submitting = true;
            const body = { email: this.email, ...this.extraPostParams };
            await API.post(this.postRoute, { body });
            this.reportSuccess();
        }
        catch (e) {
            if (isValidationError(e)) {
                // Do nothing.
            }
            else if (e.response.status === 404 && (this.treat404AsSuccess || this.custom404Message)) {
                if (this.treat404AsSuccess) {
                    this.reportSuccess();
                }
                else {
                    this.error = this.custom404Message;
                }
            }
            else {
                this.error = apiErrorMessageOrRethrow(e, 'validate_not_email');
            }
        }
        finally {
            this.submitting = false;
        }
    }
}
